import { CommonTranslations } from '../../../types';

export const COMMONS: CommonTranslations = {
  formik: {
    common: {
      required: 'Este campo es requerido.',
    },
    date: {
      typeError: 'La fecha no es válida.',
    },
    inputText: {
      matchesAlphanumeric: 'Solo se pueden introducir caracteres alfanuméricos.',
      matchesAlphabetic: 'Solo se pueden introducir caracteres alfabéticos.',
      matchesNIF: 'El formato no corresponde con NIF o NIE.',
      minLength: 'Mínimo de formikValue caracteres.',
      maxLength: 'Máximo de formikValue caracteres.',
    },
  },
  fallback: {
    1: 'Este',
    2: ' enlace no es válido,',
    3: 'vuelva a Whatsapp e inténtelo de nuevo.',
  },
};
